import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";



// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: `${process.env.REACT_APP_API_KEY}`,
  authDomain: `${process.env.REACT_APP_AUTH_DOMAIN}`,
  projectId: `${process.env.REACT_APP_PROJECT_ID}`,
  storageBucket: `${process.env.REACT_APP_STORAGE_BUCKET}`,
  messagingSenderId: `${process.env.REACT_APP_MESSAGING_SENDER_ID}`,
  appId: `${process.env.REACT_APP_APP_ID}`
/*   apiKey: "AIzaSyBzzWdK63fLC0QNtc1ec0H6rwxqRQS4yoE",
  authDomain: "writenode-ab52a.firebaseapp.com",
  projectId: "writenode-ab52a",
  storageBucket: "writenode-ab52a.appspot.com",
  messagingSenderId: "866552413432",
  appId: "1:866552413432:web:a6726361ffbf12389a4f0d" */

};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
